export default __webpack_public_path__ + "static/media/Flyer.7bf61c66.svg";